"use client";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "@/components";
import ConfirmAnimationDeleteModal from "@/components/modal/components/confirm-animation-delete";
import { useModal } from "@/hooks/use-modal";

const DeleteAnimationButton = ({ animationId }: { animationId: number }) => {
  const { openModal } = useModal();

  const onDeleteClicked = () =>
    openModal(() => <ConfirmAnimationDeleteModal id={animationId} />);

  return (
    <Button
      icon={faTrashAlt}
      type="negative"
      onClick={onDeleteClicked}
      rightAlign
    >
      Delete
    </Button>
  );
};

export { DeleteAnimationButton };
